import { Component, Inject, ViewChild } from '@angular/core';
import { ToasterServiceService } from '../../service/toaster.service';
import { Location } from '@angular/common';
import { MainService } from '../../service/main.service';
import { ApiUrls } from '../../apiRouts';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../../service/local-storage.service';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
  selector: 'app-send-invitation',
  templateUrl: './send-invitation.component.html',
  styleUrl: './send-invitation.component.scss'
})
export class SendInvitationComponent {
  memberListData: any = [];
  subEventId: any;
  originalMemberListData: any[] = [];
  userIds: any = [];
  sub2 = new Subscription;
  userId: any;
  mainData: any;
  @ViewChild('selectAllCheckbox') selectAllCheckbox!: MatCheckbox;
  selectedUserType: any;

  constructor(
    private _bottomSheet: MatBottomSheet,
    private toasterService: ToasterServiceService,
    private location: Location,
    private route: ActivatedRoute,
    private mainService: MainService,
    private localStorageService: LocalStorageService,
    private router: Router,) {
    this.userId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;
    this.route.params.subscribe((params: any) => {
      this.subEventId = params['sub_event_id'] || '';
    });
    this.sub2 = this.mainService.sendFilterData().subscribe(res => {
      this.memberListData = this.originalMemberListData.filter((user: any) => {

        const bloodGroupMatch = !res.blood_group || user.blood_group.toLowerCase() === res.blood_group.toLowerCase();
        const committeeTrimmed = user.user_type_id.toString().trim().toLowerCase();
        const resetCommitteeTrimmed = res.user_type_id.toString().trim().toLowerCase();
        const committeeMatch = !res.user_type_id || committeeTrimmed === resetCommitteeTrimmed;
        const educationTrimmed = user.education.toString().trim().toLowerCase();
        const reeducationTrimmed = res.education.toString().trim().toLowerCase();
        const educationMatch = !res.education || educationTrimmed === reeducationTrimmed;
        const currentCityMatch = !res.city_name || user.city_name.toLowerCase().includes(res.city_name.toLowerCase());
        const villageNameMatch = !res.village_name || user.village_name.toLowerCase().includes(res.village_name.toLowerCase());
        const SubdivisionMatch = !res.subdivision_name || user.subdivision_name.toLowerCase().includes(res.subdivision_name.toLowerCase());

        return bloodGroupMatch && committeeMatch && villageNameMatch && educationMatch && currentCityMatch && SubdivisionMatch;
      });
    });
  }

  ngOnInit() {
    this.getMainMember();
  }

  UpdateStatus(data: any) {
    console.log('data', data);
    this.selectedUserType = data;
    this.getMainMember();
  }

  goBackToPrevPage() {
    this.location.back();
  }
  openBottomSheet(): void {
    this._bottomSheet.open(FilterMemberForm, {
      data: this.memberListData,
    });
  }

  getMainMember() {
    let data = {
      user_id: Number(this.subEventId),
      name: "",
      address: "",
      contact_no: "",
      whatsapp_no: "",
      business: "",
      office_contact: "",
      office_address: "",
      village_id: 0,
      current_city_id: 0,
      education: "",
      dob: "",
      blood_group: "",
      image: "", // Assuming 'image' is a property of the member object
      //image_file:"",
      relation_id: 0,
      main_member_id: 0,
      maternal_name: "",
      maternal_village_id: 0,
      is_verified: 0,
      user_type_id: 0,
      password: "",
      created_by: 0,
      Action: 'SELECTNONENVITEDMEMBER',
    };
    this.mainService.putApi(ApiUrls.verifiedMemberList, data, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.mainData = res.user.map((member: any) => ({
          ...member,
          checked: false // Initialize 'checked' to false for each member
        }));
        if (this.selectedUserType) {
          this.originalMemberListData = this.mainData.filter((a: any) => a.user_type_id == this.selectedUserType);
          this.memberListData = this.mainData.filter((a: any) => a.user_type_id == this.selectedUserType);
        } else {
          this.originalMemberListData = this.mainData;
          this.memberListData = this.mainData;
        }
      }
    });
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.memberListData = this.originalMemberListData
      return;
    }
    this.memberListData = this.originalMemberListData.filter((data: any) => {
      return data.name.toLowerCase().includes(filterValue) ||
        data.contact_no.includes(filterValue);
    });
  }

  goToSendInvitation() {
    this.router.navigate(["/send-invitation/" + this.subEventId]);
  }

  // selectAllMembers(event: any) {
  //   const checked = event.checked;
  //   this.memberListData.forEach((member:any) => {
  //     member.checked = checked;
  //     if (checked && !this.userIds.includes(member.user_id)) {
  //       this.userIds.push(member.user_id);
  //     } else if (!checked) {
  //       this.userIds = this.userIds.filter((id: any) => id !== member.user_id);
  //     }
  //   });
  //   this.memberListData.forEach((member:any)  => {
  //     if (this.selectAllCheckbox) {
  //       this.selectAllCheckbox.disabled = checked;
  //     }
  //   });
  // }

  selectAllMembers(event: any) {
    if (event.checked) {
      // Select all checkboxes
      this.memberListData.forEach((member: any) => {
        member.checked = true;
        if (!this.userIds.includes(member.user_id)) {
          this.userIds.push(member.user_id);
        }
      });
    } else {
      // Deselect all checkboxes
      this.memberListData.forEach((member: any) => {
        member.checked = false;
      });
      this.userIds = [];
    }
  }

  invitationFunction(event: any, userId: any) {
    if (event.checked) {
      if (!this.userIds.includes(userId)) {
        this.userIds.push(userId);
      }
    } else {
      this.userIds = this.userIds.filter((id: any) => id !== userId);
    }
  }

  submit() {
    const stringArray = this.userIds.map((num: any) => `${num}`);
    const resultString = '[' + stringArray.join(',') + ']';
    var data: any = {
      sub_event_member_id: 0,
      sub_event_id: Number(this.subEventId),
      user_ids_json: resultString,
      created_by: this.userId,
      Action: 'INSERT'
    }
    this.mainService.postApi(ApiUrls.sendInvitationToMember, data, 1).subscribe(res => {
      if (res.status == 1) {
        this.toasterService.toastSuccess(res.response);
        this.goBackToPrevPage();
      } else {
        this.toasterService.toastError(res.response);
      }
    })
  }
}


@Component({
  selector: 'app-filter-member',
  templateUrl: 'filter-member.component.html',
  standalone: true,
  imports: [MatListModule, CommonModule, SharedModule],
})
export class FilterMemberForm {
  villageList: any = [];
  Current_City_List: any = [];
  Subdivision_Name_List: any = [];
  filter_memberForm: FormGroup;
  villageListAll: any = [];
  SubdivisionAll: any = [];
  cityListAll: any = [];
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<FilterMemberForm>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private mainService: MainService,
    private fb: FormBuilder) {
    this.filter_memberForm = this.fb.group({
      blood_group: [''],
      village_name: [''],
      contact_no: [''],
      education: [''],
      user_type_id: [''],
      city_name: [''],
      maternal_village_name: [''],
      subdivision_name: [''],
    })

    for (const key in data) {
      const element = data[key];
      this.Current_City_List.push(element.city_name);
    }
    this.Current_City_List = this.Current_City_List.filter((value: any, index: any, array: any) => array.indexOf(value) === index);

    this.getVillageDataList();
    this.getSubdivisionDataList();
    this.getCurrentCityNameList();
  }

  getCurrentCityNameList() {
    this.mainService.getApi(ApiUrls.cityList).subscribe((res: any) => {
      this.cityListAll = res.city;
    });
  }

  getVillageDataList() {
    this.mainService.getApi(ApiUrls.getAllVillageList).subscribe((res: any) => {
      this.villageListAll = res.village;

    });
  }
  getSubdivisionDataList() {
    this.mainService.getApi(ApiUrls.AllSubdivisionList).subscribe((res: any) => {
      this.SubdivisionAll = res.subdivision;
    });
  }

  Cancel() {
    this._bottomSheetRef.dismiss();
  }

  submit() {
    let data = {
      blood_group: this.filter_memberForm.value.blood_group,
      village_name: this.filter_memberForm.value.village_name,
      contact_no: this.filter_memberForm.value.contact_no,
      education: this.filter_memberForm.value.education,
      user_type_id: this.filter_memberForm.value.user_type_id,
      city_name: this.filter_memberForm.value.city_name,
      subdivision_name: this.filter_memberForm.value.subdivision_name,
    }
    this.mainService.getFilterData(data);
    this._bottomSheetRef.dismiss();
  }

}